export const learnMoreLink = 'https://support.approvalmax.com/portal/en/kb/articles/pulling-purchase-orders-from-xero';
